export default __webpack_public_path__ + "static/media/598.4fb70611.png";